import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('programa-universidad'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programa-universidad'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`programa-universidad/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`programa-universidad/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`programa-universidad/${id}`));
  },
  async registrarInscripciones(id, data) {
    return await axiosIns.post(obtenerUrlAPIPagos(`programa-universidad/${id}/registrar-inscripciones`), data);
  },
  async validarCostosPrograma(id) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`programa-universidad/${id}/validar-costos-programa`));
  },
  async findAllPorUniversidadIdBusqueda(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programa-universidad/universidad/busqueda'), {
      params: opciones.params,
    });
  },
  async findAllPaginado(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programa-universidad/paginado'), { params: opciones.params });
  },
  async consolidar(id) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`programa-universidad/${id}/consolidar`));
  },
  async establecerPlanPagoUniversidad(id, data) {
    return await axiosIns.patch(
      obtenerUrlAPIPagos(`programa-universidad/${id}/establecer-plan-pago-universidad`),
      data,
    );
  },
  async establecerCodigosEmpastados(id) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`programa-universidad/${id}/establecer-codigos-empastados`));
  },
  async findAllSedeIdBusqueda(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programa-universidad/busqueda'), { params: opciones.params });
  },
  async agregarCEUB(id, data) {
    return await axiosIns.post(obtenerUrlAPIPagos(`programa-universidad/${id}/agregar-ceub`), data);
  },
  async obtenerCEUB(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`programa-universidad/${id}/obtener-ceub`));
  },
  async inscritosReportados(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programa-universidad/inscritos-reportados'), {
      params: opciones.params,
    });
  },
  async cantidadInscritos(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programa-universidad/cantidad-inscritos'), {
      params: opciones.params,
    });
  },
};
